import { enums, Infer } from "superstruct";

export const PROJECT_ORDER_BY_OPTIONS = ["CREATED_AT", "UPDATED_AT"] as const;

const ProjectOrderByStruct = enums(PROJECT_ORDER_BY_OPTIONS);

export type ProjectOrderBy = Infer<typeof ProjectOrderByStruct>;
